module.exports = __webpack_public_path__ + "fonts/SephoraSans-Bold.1ca72a0.woff2";